// 天猫菜鸟
const map = {
  dropOrderList: () => import('@/views/inventory/DropOrderList'),
  tosendOrderList: () => import('@/views/inventory/TosendOrderList'),
  repertoryComparison: () => import('@/views/inventory/RepertoryComparison'),
  // sql
  taskList: () => import('@/views/mysql/TaskList')
}

export default map
